import { createLanguageAssertion } from './src/createLanguageAssertion';

/**
 * Detect if string match english language.
 * Used BCP47 standard for locale names.
 */
export const isEnLanguageCode = createLanguageAssertion({ matches: [/^(en(-[a-zA-Z]{2})?)$/] });
